/* jshint browser: true */

const Marionette = require('backbone.marionette');
const templates = require('../templates');
const TooltipView = require('./main_booking_tooltip.js');
const lightenDarkenColor = require('../extensions/lighten-darken-color.js');
const app = require('../app.js');
const $ = window.jQuery;

module.exports = Marionette.LayoutView.extend({
  tagName: 'li',
  template(model) {
    if (model.booking.get('isFromScheduledBooking')) {
      return templates.main_booking(model);
    }
    return templates.main_booking_special(model);
  },
  serializeModel() {
    const activityColor = this.model.get('activity').get('color');
    const specialColor = lightenDarkenColor.lightenDarken(activityColor, 20);
    const specialColorBorder = lightenDarkenColor.lightenDarken(activityColor, -20);
    const specialTextColor = this.getColorByBgColor(specialColor);

    return {
      booking: this.model,
      specialColor,
      specialColorBorder,
      specialTextColor
    };
  },
  onRender() {
    const activity = this.model.get('activity');

    this.$el.qtip({
      content: this.$('.booking_tooltip'),
      style: {
        classes: 'qtip-light',
        tip: {
          border: 0,
          width: 20,
          height: 20
        }
      },
      position: {
        my: 'bottom right',
        target: 'mouse',
        adjust: {
          y: -25,
          mouse: false
        },
        viewport: $(window)
      },
      show: 'click',
      hide: 'unfocus',
      events: {
        show(event, api) {
          $(this).appendTo(api.get('position.container'));
          api.elements.content.css('border-color', activity.get('color'));
          api.elements.content.css('background-color', activity.get('color'));
          app.vent.trigger('openActivityPopup');
        },
        hide() {
          app.vent.trigger('closeActivityPopup');
        }
      }
    });
  },
  regions: {
    tooltip: '.booking_tooltip'
  },
  onBeforeShow() {
    this.showChildView(
      'tooltip',
      new TooltipView({
        model: this.model
      })
    );
  },
  getColorByBgColor(bgColor) {
    if (!bgColor) {
      return '';
    }

    const colors = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(bgColor);
    const red = parseInt(colors[1], 16);
    const green = parseInt(colors[2], 16);
    const blue = parseInt(colors[3], 16);

    if (red * 0.299 + green * 0.587 + blue * 0.114 > 186) {
      return '#000000';
    }

    return '#ffffff';
  }
});



// WEBPACK FOOTER //
// ./src/views/main_booking.js